import axios from 'axios'

export default {
  developererrorlogList (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/developererrorlog', { params: opts })
        .then(({ data }) => {
          context.commit('DEVELOPERERRORLOG_LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
